var $20889bf3c0d36a01$exports = {};
$20889bf3c0d36a01$exports = {
    "alert": `Varsel`,
    "dismiss": `Lukk`
};


export {$20889bf3c0d36a01$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
